import { AfterContentInit, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CustomisableVariables } from '@shared/models/customisable-variables';
import { CustomisableVariablesService } from '@shared/services/customisable-variables.service';
import { SiteSettingsService } from '@shared/services/site-settings.service';
import { ISiteSettings } from '@shared/shared/interfaces/site-settings.interfaces';
import { Angulartics2Segment } from 'angulartics2';
import { Observable, Subject } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'tm-ref1-eligibility-check',
  templateUrl: './tm-ref1-eligibility-check.component.html',
  styleUrls: ['./tm-ref1-eligibility-check.component.scss'],
})
export class TMRef1EligibilityCheckComponent implements OnInit, AfterContentInit, OnDestroy {
  public eligibilityForm: UntypedFormGroup;
  public customVariables$: Observable<CustomisableVariables>;
  public siteSettings$: Observable<ISiteSettings> = this.siteSettingsService.fetchSiteSettings();

  @Output() public changedEligibilityForm = new EventEmitter<any>();

  private clientPath: string;
  private unsubscribe$ = new Subject<void>();
  constructor(
    private customisableVariablesService: CustomisableVariablesService,
    private siteSettingsService: SiteSettingsService,
    private angulartics2Segment: Angulartics2Segment
  ) {
    this.customVariables$ = this.customisableVariablesService.variables;
  }

  public ngOnInit() {
    this.siteSettings$
      .pipe(
        filter((siteSettings: ISiteSettings) => this.siteSettingsService.settingsRetrieved && !!siteSettings.id),
        take(1)
      )
      .subscribe((siteSettings: ISiteSettings) => {
        this.clientPath = siteSettings?.fe_configuration?.path;
      });
    this.angulartics2Segment.eventTrack('EligibilityPageLoaded', { clientPath: this.clientPath });
  }

  public ngAfterContentInit() {
    this.eligibilityForm = new UntypedFormGroup({
      indentifier: new UntypedFormControl('', [Validators.required]),
    });

    this.eligibilityForm.valueChanges
      .pipe(
        filter((value) => !!value),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(() => {
        this.changedEligibilityForm.emit(this.eligibilityForm);
      });
  }

  public ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
